module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABXElEQVRIiaXWMUscQRQA4O8GC9HiGiGtaWMdsb1iA0GTKoRAQorkdxmtrUStZgn2dpJa9AcEAgElsUrhHFyW25nZvdfNmzf77Sz7dmcSY3yJI2zjHF/xoDKapvlv3LbtBr7hLW7xZS0BO6nmA57hYAjUAS4wS6kXOAx43qmdpcKNFYF5bAecLVkzCMoAcDqJMeYKLpUfXXF9SBc4SIlulHZUBJqmeQgpMQaqAiAsTAyBqoEuUgttDQGWITXQ3RCgDylBm0OAHFKCqoESMoc+4k/P/D3e54AaZIpTrPfMb+IkdfwoZIqI3cKNzHCRg/qQHHA/FFqG5IBLT/+d3j5aBnWRHHCO1/gp30ff27ad9iEl4B3+pnHu9d5DXITmSA3w2MnnoN1FaBJjHAMsRu5jeYVXAccrAFIj5nZ0FFLBKKASehNwswpQAd0FfMY1fuFwDNCB9j0ds37jBz79AxYen6ufAgaHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-close.png
// module id = p6I1
// module chunks = 1